import { ArrowUpRight, Rocket } from "lucide-react";

export default function DigtekRocketCTA() {
    return (
        <section
            data-testid="digtek-rocket-cta"
            className="relative py-24 lg:py-32 overflow-hidden bg-digtek-lime"
        >
            {/* Background dot pattern */}
            <div
                aria-hidden
                className="absolute inset-0 opacity-30 digtek-dot-ring"
                style={{ backgroundSize: "24px 24px" }}
            />
            {/* Floating rocket */}
            <div className="absolute -top-6 right-8 lg:right-24 digtek-rocket">
                <div className="w-40 h-40 rounded-full bg-digtek-header flex items-center justify-center shadow-[0_30px_80px_-20px_rgba(23,1,44,.5)]">
                    <Rocket className="w-16 h-16 text-digtek-lime -rotate-45" />
                </div>
            </div>

            <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
                <div className="max-w-[820px]">
                    <p className="digtek-eyebrow !text-digtek-header before:!bg-digtek-header mb-6">
                        <span>Ready to ship?</span>
                    </p>
                    <h2
                        data-testid="rocket-cta-heading"
                        className="font-display font-bold text-[44px] sm:text-[60px] lg:text-[80px] leading-[0.98] text-digtek-header"
                    >
                        Stay connected
                        <br />
                        with{" "}
                        <em className="not-italic text-digtek-purple">
                            cutting-edge
                        </em>{" "}
                        growth.
                    </h2>
                    <p className="mt-6 text-digtek-header/80 text-lg max-w-[520px]">
                        30-minute discovery call. No sales script, no NDA
                        gymnastics. We'll tell you what we'd actually build if we
                        were you.
                    </p>
                    <div className="mt-10 flex flex-wrap items-center gap-4">
                        <a
                            href="/#contact"
                            data-testid="rocket-cta-primary"
                            className="btn-digtek"
                        >
                            Talk to a specialist
                            <ArrowUpRight className="w-4 h-4" />
                        </a>
                        <a
                            href="/#pricing"
                            data-testid="rocket-cta-secondary"
                            className="btn-digtek-outline"
                        >
                            See pricing
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
